




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Overlay extends Vue {
  private get isVisible(): boolean {
    return this.$store.state.ui.overlay;
  }

  private close(): void {
    this.$store.commit('ui/setOverlay', false);
  }

  private beforeCreate(): void {
    (document.documentElement as HTMLElement).classList.add('no-scroll');
  }

  private destroyed(): void {
    (document.documentElement as HTMLElement).classList.remove('no-scroll');
  }
}
